var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 71.162,
    viewBox: "0 0 100 71.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14974",
    "data-name": "Grupo 14974",
    transform: "translate(-344.604 -621.204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72041",
    "data-name": "Trazado 72041",
    d: "M475.413,109.013a2.9,2.9,0,1,1,2.9-2.9,2.9,2.9,0,0,1-2.9,2.9",
    transform: "translate(-33.713 518)",
    fill: "#0092ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72042",
    "data-name": "Trazado 72042",
    d: "M475.284,149.569a2.9,2.9,0,1,1,2.9-2.9,2.9,2.9,0,0,1-2.9,2.9",
    transform: "translate(-33.688 510.12)",
    fill: "#0092ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72043",
    "data-name": "Trazado 72043",
    d: "M475.155,190.125a2.9,2.9,0,1,1,2.9-2.9,2.9,2.9,0,0,1-2.9,2.9",
    transform: "translate(-33.663 502.241)",
    fill: "#0092ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72044",
    "data-name": "Trazado 72044",
    d: "M436.531,109.013a2.9,2.9,0,1,1,2.9-2.9,2.9,2.9,0,0,1-2.9,2.9",
    transform: "translate(-26.159 518)",
    fill: "#0092ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72045",
    "data-name": "Trazado 72045",
    d: "M436.4,149.569a2.9,2.9,0,1,1,2.9-2.9,2.9,2.9,0,0,1-2.9,2.9",
    transform: "translate(-26.134 510.12)",
    fill: "#0092ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72046",
    "data-name": "Trazado 72046",
    d: "M436.273,190.125a2.9,2.9,0,1,1,2.9-2.9,2.9,2.9,0,0,1-2.9,2.9",
    transform: "translate(-26.109 502.241)",
    fill: "#0092ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72047",
    "data-name": "Trazado 72047",
    d: "M397.648,109.013a2.9,2.9,0,1,1,2.9-2.9,2.9,2.9,0,0,1-2.9,2.9",
    transform: "translate(-18.604 518)",
    fill: "#0092ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72048",
    "data-name": "Trazado 72048",
    d: "M397.52,149.569a2.9,2.9,0,1,1,2.9-2.9,2.9,2.9,0,0,1-2.9,2.9",
    transform: "translate(-18.579 510.12)",
    fill: "#0092ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72049",
    "data-name": "Trazado 72049",
    d: "M397.391,190.125a2.9,2.9,0,1,1,2.9-2.9,2.9,2.9,0,0,1-2.9,2.9",
    transform: "translate(-18.554 502.241)",
    fill: "#0092ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72050",
    "data-name": "Trazado 72050",
    d: "M358.766,109.013a2.9,2.9,0,1,1,2.9-2.9,2.9,2.9,0,0,1-2.9,2.9",
    transform: "translate(-11.05 518)",
    fill: "#0092ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72051",
    "data-name": "Trazado 72051",
    d: "M358.638,149.569a2.9,2.9,0,1,1,2.9-2.9,2.9,2.9,0,0,1-2.9,2.9",
    transform: "translate(-11.025 510.12)",
    fill: "#0092ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_72052",
    "data-name": "Trazado 72052",
    d: "M358.509,190.125a2.9,2.9,0,1,1,2.9-2.9,2.9,2.9,0,0,1-2.9,2.9",
    transform: "translate(-11 502.241)",
    fill: "#0092ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanel);
export default __webpack_public_path__ + "static/media/panel.255ff8e0834b413aecbb9c850d3d1fc1.svg";
export { ForwardRef as ReactComponent };